<script>
  import createProjectStore from '../stores/project'
  import createLeaderboardStore from '../stores/leaderboard'
  import createCategoryLeaderboardStore from '../stores/category-leaderboard'
  import createScoresStore from '../stores/scores'
  import createLiveStore from '../stores/live'

  import {Link} from "svelte-routing";
  import Message from '../components/Message.svelte'
  import Loader from '../components/Loader.svelte'
  import ProjectHeader from '../components/ProjectHeader.svelte'
  import ProjectDesc from '../components/ProjectDesc.svelte'
  import Leaderboard from '../components/Leaderboard.svelte'
  import {dateFromString} from '../functions-common/date'
  import Maps from '../components/Maps.svelte'

  export let id;
  export let subPage = 'ranking';

  onSubPageSelected(subPage);

  let types = [];

  function onLeaderboardsUpdated() {
    if (!categoryLeaderboard || !$categoryLeaderboard) return;

    types = [{name: 'Global', type: 'global'}]
      .concat(Object.values(categoryLeaderboard
        ? $categoryLeaderboard.reduce((cum, p) => {
          cum[p.category_name] = {
            name: p.category_name[0].toUpperCase() + p.category_name.substr(1),
            type: p.category_name,
          }

          return cum;
        }, {})
        : {}),
      )
  }

  const download = (data, filename, type) => {
    const link = document.createElement("a");
    if (link.download === undefined) return false;

    const blob = new Blob([data], {type});

    link.setAttribute("href", URL.createObjectURL(blob));
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  }

  async function onPlaylistDownload(name, scores) {
    if (!scores || !scores.length) return;

    const hashes = Object.values(
      scores.reduce((cum, s) => {
        const {hash, difficulty} = s;

        if (!cum[hash]) cum[hash] = {hash, difficulties: []};

        if (!cum[hash].difficulties.filter(d => d.characteristic === 'Standard' && d.name === difficulty).length)
          cum[hash].difficulties.push({characteristic: "Standard", name: difficulty});

        return cum;
      }, {}),
    );

    const icon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABmJLR0QA5ADnAOwhBrIWAAAACXBIWXMAAAsTAAALEwEAmpwYAAABuklEQVR42u3cOW7CUAAEUNviFhQIEEgsNTXn4gCci5oaKJBAouAaQO2CwpKXv7zXxUqRkNH4T4JTTherb0G2Ki+BACAACAACgAAgAAgAAoAAIAAIAAKAACAACADJGQ39Bcwn49rHj9c7y+saAAFAAOhZ6U2hGgArILwVcD59atd3+yqq65fDpnZ9e7xaAbgFIABYAWgAEl0Bbf1u/N/p+nm/1a7PluskVsBQfzvQAG4BCABWABoAK6C7FdD083NbAW29nhoAAUAAsALQAFgBVoAGQAAQAKwANABdr4Cmp1krYNinhjWAWwACgBWABsAK6J8V4OlgBAABwAro63suisLyybgB/PBjXgH+R5AGQAAQAKwANACxr4DY10Esp30NgAAgAFgBaADCXwGhrYPYT/saAAFAALAC0ADEuwK6XgepnvY1AAKAAGAFoAFIbwW0tQ5SPe1rAAQAAcAKQANgBVgBGgABQACsACtAA2AFpHrab2sFeEcQbgEIAFYAGgArILTTvqeDNQACgABgBaAByG0FhHZdAyAACABWABoAAUAAEAAEAAFAABAABAABQAAQAAQAAUAAEAD69AMs8sts2pWH4wAAAABJRU5ErkJggg==";
    const playlist = {
      AllowDuplicates: false,
      playlistTitle: name,
      playlistAuthor: "motzel",
      playlistDescription: "",
      image: icon,
      songs: hashes,
    }

    download(JSON.stringify(playlist), (name + "-" + (new Date()).toISOString()).replace(/:/g, '_') + '.json', 'application/json;charset=utf-8;');
  }

  let liveTimers = {};

  function liveRefresh() {
    if (!live) return;

    live.refresh();
  }

  function setLiveTimers(liveData) {
    if (!live) return;

    Object.keys(liveTimers).map(playerId => {
      if (!liveData[playerId]) {
        clearTimeout(liveTimers[playerId]);
        delete liveTimers[playerId];
      }
    })

    Object.values(liveData).map(p => Object.values(p).map(l => {
      if (!l || !l.max_end_at || !l.player_id || !l.map_id) return;

      const {player_id: playerId, max_end_at: maxEndAt} = l;

      const maxEndDate = dateFromString(maxEndAt)
      if (!maxEndDate) return;

      if (liveTimers[playerId]) {
        clearTimeout(liveTimers[playerId]);
      }

      const timeout = maxEndDate - new Date();
      if (timeout < 0) return;

      liveTimers[playerId] = setTimeout(liveRefresh, timeout)
    }));
  }

  function onSubPageSelected(newSubPage) {
    if (!['ranking', 'maps'].includes(subPage)) subPage = 'ranking';
    else subPage = newSubPage;
  }

  $: project = id ? createProjectStore(id) : null;
  $: scores = id ? createScoresStore(id) : null;
  $: live = id ? createLiveStore(id) : null;
  $: setLiveTimers($live);
  $: if ($scores) {
    liveRefresh();
  }
  $: globalLeaderboard = id ? createLeaderboardStore(id) : null;
  $: categoryLeaderboard = id ? createCategoryLeaderboardStore(id) : null;

  $: onLeaderboardsUpdated($globalLeaderboard, $categoryLeaderboard);
  $: projectLoading = project ? project.loading : null;
  $: scoresLoading = scores ? scores.loading : null;
  $: globalLeaderboardLoading = globalLeaderboard ? globalLeaderboard.loading : null;
  $: categoryLeaderboardLoading = categoryLeaderboard ? categoryLeaderboard.loading : null;
  $: loading = $projectLoading || $scoresLoading || $globalLeaderboardLoading || $categoryLeaderboardLoading ? true : false;
</script>

<section class="nes-container is-dark is-rounded with-title">
  {#if project && $project}
    <ProjectHeader project={$project} withPlaylistIcon={$scores && $scores.length}
                   on:playlist={() => onPlaylistDownload($project.name, $scores)} />

    <section class="desc">
      <ProjectDesc project={$project}/>
    </section>

    <h2>
      <button type="button" class={`nes-btn ${subPage === 'ranking' ? 'is-primary' : 'is-default'}`}
              on:click={() => onSubPageSelected('ranking')}
      >
        Ranking
      </button>
      <button type="button" class={`nes-btn ${subPage === 'maps' ? 'is-primary' : 'is-default'}`}
              on:click={() => onSubPageSelected('maps')}
      >
        Maps
      </button>
    </h2>

    {#if subPage === 'ranking'}
      <Leaderboard globalLeaderboard={globalLeaderboard ? $globalLeaderboard : null}
                   categoryLeaderboard={categoryLeaderboard ? $categoryLeaderboard : null}
                   {types} scores={$scores} live={$live} {loading}
      />
    {:else if subPage === 'maps'}
      <Maps {id} scores={$scores} {types} {loading} />
    {/if}

  {:else if loading}
    <Loader text="Loading..." />
  {:else}
    <section class="message-list">
      <Message>
        It looks like the selected project does not exist.
        Take a look in the <Link to="/projects">Archive</Link> to check out all projects.
      </Message>
    </section>
  {/if}
</section>

<style>
  .nes-container {
      min-height: 10rem;
  }

  .desc {
      margin-bottom: 3rem;
  }

  h2 {
      margin-bottom: 2rem;
      text-align: center;
  }

  @media screen and (max-width: 767px) {
      h2 {
          text-align: center;
      }
  }
</style>